import OofRollUpViewState from '../../store/schema/OofRollUpViewState';

export const OOF_ITEM_CLASS_REGEX = /ipm.note.rules.ooftemplate.microsoft/i;

export function createOofRollUpViewState(itemClass: string): OofRollUpViewState {
    return {
        isOofItem: OOF_ITEM_CLASS_REGEX.test(itemClass),
        oofReplyNodeIds: [],
        isOofRollUpExpanded: false,
    };
}
